import { render, staticRenderFns } from "./UserMessages.vue?vue&type=template&id=4f722a71&scoped=true&"
import script from "./UserMessages.vue?vue&type=script&lang=js&"
export * from "./UserMessages.vue?vue&type=script&lang=js&"
import style0 from "./UserMessages.vue?vue&type=style&index=0&id=4f722a71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f722a71",
  null
  
)

export default component.exports